import script from "./ProjectsGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsGrid.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsGrid.vue?vue&type=style&index=0&id=4c21d30c&lang=scss"

const __exports__ = script;

export default __exports__